import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center gap-1.5 text-xs font-medium tracking-[0.1px] whitespace-nowrap text-parameter-text cursor-pointer" }
const _hoisted_2 = {
  key: 0,
  class: "w-full overflow-hidden"
}
const _hoisted_3 = { class: "flex flex-col w-full mt-2" }
const _hoisted_4 = { class: "flex items-center gap-1.5 text-xs font-medium tracking-[0.1px] whitespace-nowrap text-parameter-text" }

import {ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'itemV3ShowMore',
  props: {
    hasMore: { type: Boolean, default: true }
  },
  setup(__props: any) {



const showMore = ref(false);

const toggleMore = () => {
  showMore.value = !showMore.value;
};

const onBeforeEnter = (el: Element) => {
  (el as HTMLElement).style.height = '0px';
};

const onEnter = (el: Element) => {
  const target = el as HTMLElement;
  requestAnimationFrame(() => {
    target.style.transition = 'height 300ms ease';
    target.style.height = `${target.scrollHeight}px`;
  });
};

const onAfterEnter = (el: Element) => {
  const target = el as HTMLElement;
  target.style.transition = '';
  target.style.height = 'auto';
};

const onBeforeLeave = (el: Element) => {
  const target = el as HTMLElement;
  target.style.height = `${target.scrollHeight}px`;
};

const onLeave = (el: Element) => {
  const target = el as HTMLElement;
  requestAnimationFrame(() => {
    target.style.transition = 'height 300ms ease';
    target.style.height = '0px';
  });
};

const onAfterLeave = (el: Element) => {
  (el as HTMLElement).style.transition = '';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.hasMore && !showMore.value)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "flex w-full items-center gap-3 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536] mt-2",
          "aria-expanded": "false",
          onClick: toggleMore
        }, [
          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
          _createElementVNode("span", _hoisted_1, [
            _renderSlot(_ctx.$slots, "more-label", {}, () => [
              _cache[0] || (_cache[0] = _createTextVNode("Mehr anzeigen", -1))
            ]),
            _cache[1] || (_cache[1] = _createElementVNode("svg", {
              "aria-hidden": "true",
              viewBox: "0 0 12 12",
              fill: "none",
              class: "size-2.5 shrink-0 text-[#555956]"
            }, [
              _createElementVNode("path", {
                d: "m1.5 4 4.5 4 4.5-4",
                stroke: "currentColor",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1))
          ]),
          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_Transition, {
      onBeforeEnter: onBeforeEnter,
      onEnter: onEnter,
      onAfterEnter: onAfterEnter,
      onBeforeLeave: onBeforeLeave,
      onLeave: onLeave,
      onAfterLeave: onAfterLeave
    }, {
      default: _withCtx(() => [
        (showMore.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "default"),
                _createElementVNode("button", {
                  type: "button",
                  class: "mt-4 flex w-full items-center gap-3 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#8b6536]",
                  "aria-expanded": "true",
                  onClick: toggleMore
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1)),
                  _createElementVNode("span", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "less-label", {}, () => [
                      _cache[4] || (_cache[4] = _createTextVNode("Weniger anzeigen", -1))
                    ]),
                    _cache[5] || (_cache[5] = _createElementVNode("svg", {
                      "aria-hidden": "true",
                      viewBox: "0 0 12 12",
                      fill: "none",
                      class: "size-2.5 shrink-0 rotate-180 text-[#555956]"
                    }, [
                      _createElementVNode("path", {
                        d: "m1.5 4 4.5 4 4.5-4",
                        stroke: "currentColor",
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round"
                      })
                    ], -1))
                  ]),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "h-px flex-1 bg-[#e7ddcc]" }, null, -1))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 3
    })
  ], 64))
}
}

})